import React, { useEffect, useState } from 'react'
import { DashboardContainer } from '../../funcs/utils'
import { useSelector } from 'react-redux'
import { TITLE_AI_REPORT } from '../../constants/constants';
import { getPotentialReport } from '../../dashboard/user/actions';
import PotentialReport from './components/PotentialReport/PotentialReport';
import { convertEpochTimeToDate } from '../../helper/helpers';

const PotentialReportAI = ({ username, index }) => {
    const client = useSelector(state => state.client);
    const { width, height, device } = useSelector(state => state.app);
    const { token } = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false)
    const [potentialReport, setPotentialReport] = useState();
    const [timestamp, setTimestamp] = useState();

    useEffect(() => {
        const fetchPotentialReport = async () => {
            try {
                const response = await getPotentialReport(token, username, index);
                const { text, timestamp_ms } = response;
                const date = convertEpochTimeToDate(timestamp_ms);

                setPotentialReport(text);
                setTimestamp(date);
            } catch (error) {
                setIsError(true);
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        }

        fetchPotentialReport();
    }, [])

    return (
        <DashboardContainer 
            client={client}
            device={{ width, height, device }}
            title={TITLE_AI_REPORT}
        >
            { !isLoading && <div style={{ fontSize: "12px" }}>Generated on {timestamp}</div> }
            { isLoading &&
                <div style={{ fontWeight: "bold", margin: '16px 0' }}>
                    Your analysis may take a few minutes to generate. Please be patient as the AI reviews your portfolio.
                </div>
            }
            <PotentialReport text={potentialReport} isLoading={isLoading} isError={isError} />
        </DashboardContainer>
    )
}

export default PotentialReportAI